<script lang="ts">
  import { ariaLabel } from "../../../Utils/ariaLabel.js"
  import { Translation } from "../../i18n/Translation"
  import Pencil from "@babeard/svelte-heroicons/solid/Pencil"

  /**
   * A small, round button with an edit-icon (and aria-labels etc)
   */
  /**
   * What arialabel to apply onto this button?
   */
  export let arialabel: Translation = undefined
  export let ariaLabelledBy: string = undefined
</script>

<div class="mt-1 h-8 w-8 shrink-0 self-start">
  <!--edit-button class is a trigger for hover on the parent elements, not to style -->

  <button
    class="as-link edit-button hover-alert"
    on:click
    style="border-radius: 0.25rem;     padding: 0.25rem"
    aria-labelledby={arialabel === undefined ? ariaLabelledBy : undefined}
    use:ariaLabel={arialabel}
  >
    <Pencil class="h-6 w-5 " />
  </button>
</div>
